import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import HomeSection from './HomeSection';
import apiService from '../../services/ApiService';
import type { HomeClubShortcut } from '../../types/communityPosts';

interface HomeMyClubsProps {
  clubs: HomeClubShortcut[];
}

export const HomeMyClubs: React.FC<HomeMyClubsProps> = ({ clubs }) => {
  const navigate = useNavigate();
  const list = clubs.slice(0, 6);
  if (!list.length) return null;

  return (
    <HomeSection
      title="Your clubs"
      description="Jump back into the groups you belong to."
      action={
        <Button type="button" variant="ghost" size="sm" onClick={() => navigate('/clubs')}>
          Browse clubs
        </Button>
      }
    >
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 list-none">
        {list.map((club) => (
          <li key={club.id}>
            <button
              type="button"
              onClick={() => navigate(club.href || `/clubs/${club.slug}`)}
              className="w-full h-full text-left rounded-2xl border border-white/[0.06] bg-[#0c0c0c]/70 px-4 py-3.5 flex items-center gap-3 hover:border-white/[0.12] cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400 transition-colors"
            >
              {club.logo_path ? (
                <img
                  src={apiService.getFileUrl(club.logo_path) || club.logo_path}
                  alt=""
                  className="w-11 h-11 rounded-full object-cover border border-white/[0.08] shrink-0"
                />
              ) : (
                <span
                  className="w-11 h-11 rounded-full bg-[#111] border border-white/[0.08] flex items-center justify-center text-sm font-semibold text-orange-300 shrink-0"
                  aria-hidden
                >
                  {(club.name || '?').charAt(0).toUpperCase()}
                </span>
              )}
              <span className="min-w-0">
                <span className="block text-white font-medium truncate">{club.name}</span>
                <span className="block text-xs text-gray-500 capitalize mt-0.5">
                  {[club.role, club.region].filter(Boolean).join(' · ')}
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </HomeSection>
  );
};

export default HomeMyClubs;
